import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
// import { ScanQROrderResponse } from '../models';

export class ScanQROrderState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  // public ScanQROrder: ScanQROrderResponse;
  public siteId: string;
  public orderFromSite: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    // this.ScanQROrder = null;
    this.siteId = null;
    this.orderFromSite = null;
  }
}
